import { useUI } from "@/lib/theme";

export default function Footer() {
  const { t } = useUI();
  return (
    <footer className="mt-12 border-t border-line pt-6 text-xs text-muted">
      <div className="flex flex-wrap items-center justify-center gap-x-2.5 gap-y-1 text-center">
        <span>
          {t("footer_by")} <span className="font-medium text-fg">Rafael Montes Useletti</span>
        </span>
        <span className="text-line">·</span>
        <span>
          {t("footer_contact")}:{" "}
          <a href="mailto:rmontestt@gmail.com" className="transition hover:text-accent">
            rmontestt@gmail.com
          </a>
        </span>
        <span className="text-line">·</span>
        <a
          href="https://www.linkedin.com/in/rafael-montes-useletti/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn"
          className="inline-flex items-center gap-1 transition hover:text-accent"
        >
          <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden>
            <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14zM8.34 9.67H5.67V18.3h2.67V9.67zM7 5.67a1.55 1.55 0 1 0 0 3.1 1.55 1.55 0 0 0 0-3.1zm11.33 7.93c0-2.3-1.23-3.37-2.87-3.37-1.32 0-1.91.73-2.24 1.24v-1.07h-2.67c.04.75 0 8.63 0 8.63h2.67v-4.82c0-.24.02-.48.09-.65.19-.48.63-.98 1.36-.98.96 0 1.34.73 1.34 1.8v4.65h2.67l-.02-5.26z" />
          </svg>
          LinkedIn
        </a>
      </div>
    </footer>
  );
}
